import { getGraphql } from '../static/graphql/getGraphql.js'

export const state = () => ({
  loading: [],
  withdrawalComplete: false,
  withdrawalError: false,
  withdrawalConfirmationCode: '',
  withdrawalPayload: undefined,
})

export const mutations = {
  setLoading(state, payload) {
    state.loading.push(payload.key)

    // unique the array
    state.loading = [...new Set(state.loading)]

    // remove
    if (!payload.value) {
      state.loading = state.loading.filter((e) => e !== payload.key)
    }
  },
  clearData(state) {
    state.withdrawalComplete = false
    state.withdrawalError = false
  },
  setWithdrawalPayload(state, payload) {
    state.withdrawalPayload = payload
  },
  setWithdrawalComplete(state, payload) {
    state.withdrawalComplete = payload
  },
  setWithdrawalConfirmationCode(state, payload) {
    state.withdrawalConfirmationCode = payload
  },
  setWithdrawalError(state, payload) {
    state.withdrawalError = payload
  },
}

export const actions = {
  async withdraw(context, args) {
    context.commit('setLoading', { key: 'withdraw', value: true })

    let response

    console.log('**** entered withdraw ******')

    try {
      const mutationQuery = await getGraphql('withdraw-funds.graphql')
      const variables = {
        accountUuid: context.state.withdrawalPayload.accountUuid,
        destinationEntityPaymentUuid:
          context.state.withdrawalPayload.paymentAccountUuid,
        amount: context.state.withdrawalPayload.amount,
        reason: context.state.withdrawalPayload.reason,
      }

      response = await this.$axios.$post('/GRAPHQL_URL/', {
        query: mutationQuery,
        variables,
      })

      console.log(response)
      if (!response.errors) {
        context.commit('setWithdrawalComplete', true)
        context.commit(
          'setWithdrawalConfirmationCode',
          response.data.me.funds.customWithdrawalFunds.memberPayment
            .memberPaymentUuid
        )
      } else {
        context.commit('setWithdrawalError', true)
      }
      // context.commit('setWithdrawalConfirmationCode', 'abcd-efgh')
    } catch (e) {
      console.log('error while withdrawing funds', e)
    } finally {
      context.commit('setLoading', { key: 'withdraw', value: false })
    }

    return response
  },
}
